import styles from './course-report.module.scss';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { useCourseTableHook } from '../../../requestUtils';
import { ChangeEvent, useState } from 'react';
import { CheckboxLabel, CreateHeaders, HeaderSizeEnum, currencyHeader, textHeader, dateHeader, SumRows } from '@frontend-workspace/react-shared-lib';
import { IRegistrationPeriod } from '../../../_models/registration-period';
import CourseReportSkeleton from './course-report-skeleton';
import { addDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CourseReportProps { }

export function CourseReport(props: CourseReportProps) {
  const { t } = useTranslation();
  const [includeFocusUsers, setIncludeFocusUsers] = useState<boolean>(false);
  const { data: registrationsInPeriod, isLoading, dateRange, onDateChange } = useCourseTableHook<IRegistrationPeriod>(`course/registrations/inPeriode`, { startDate: new Date(), endDate: addDays(new Date(), 1) });
  const { data: courseSoldInPeriod, isLoading: isLoadingInPeriod, dateRange: soldDateRange, onDateChange: soldDateChange } = useCourseTableHook(`course/soldInPeriode2/${includeFocusUsers}`, { startDate: new Date(new Date().getFullYear(), 0, 1), endDate: new Date() });

  const handleIncludeFocusUsers = (event: ChangeEvent<Element>, checked: boolean) => setIncludeFocusUsers(checked);

  return (<>
    <div className='mb-5'>
      <label>{t('courseReport.theseAreOnCourse')}</label>
      {isLoading ? <CourseReportSkeleton /> :
        <WebkuaTable
          data={registrationsInPeriod}
          supportFutureDates={true}
          dateRange={dateRange}
          onSetDateRange={onDateChange}
          headers={CreateHeaders([
            dateHeader("date", t('standard.date')),
            textHeader("courseName", t('standard.courseName'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("place", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("company", t('standard.company'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("invoiceContactPerson", t('standard.courseParticipant'), HeaderSizeEnum.EXTRA_LARGE)
          ])}
        />}
    </div>
    <label>{t('courseReport.courseDeliveredDuringPeriod')}</label>
    <div className='d-flex my-3 mb-sm-0'>
      <CheckboxLabel
        label={t('courseReport.includeParticipantsFromFocus')}
        checked={includeFocusUsers || false}
        onChange={handleIncludeFocusUsers}
      />
    </div>
    {isLoadingInPeriod ? <CourseReportSkeleton /> :
      <WebkuaTable
        data={courseSoldInPeriod}
        dateRange={soldDateRange}
        onSetDateRange={soldDateChange}
        headers={CreateHeaders([
          dateHeader("date", t('standard.date')),
          textHeader("courseName", t('standard.courseName'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("place", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("participants", t('courseReport.numberOfParticipants'), HeaderSizeEnum.MEDIUM, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header",
            summary: SumRows
          }),
          currencyHeader("sum", "Sum", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header",
            summary: SumRows
          })
        ])}
      />}
  </>);
}

export default CourseReport;
